import * as Yup from "yup";

export const initialValues = {
  regNumber: "",
  ownerShipType: "",
  file: "",
};

export const validationSchema = Yup.object({
  regNumber: Yup.string()
    .min(3, "Minimum 8 Letters Required")
    .max(15, "Maximum 10 Letter Allowed")
    .required("Required Field"),
  ownerShipType: Yup.string().required("Required Field"),
  file: Yup.string()
    .required("Required Field"),
});
